import React, { useEffect, useState, useRef } from 'react';

import CloseIcon from "../../assets/images/close.png";

import { getGeneralDashboardData, getDepartmentDashboardData } from "../../store/actions/dashboardActions";
import { getRisks_Report, getAllRisks_Report, getControls_Report, getControls_Search, getActions_Report, getIncidents_Report, getLevels } from "../../store/actions/riskActions";
import { getAllDepartments, getDepartmentName } from "../../store/actions/departmentActions";

import { connect } from "react-redux";
import { compose } from "redux";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import RiskByDepartment from '../Charts/General/RiskByDepartment';
import RiskLevelByDepartment from '../Charts/General/RiskLevelByDepartment';
import SimplePercentageChart from '../Charts/General/ControlByType';
import SimplePercentagePieChart from '../Charts/General/ControlPieChart';
import RiskLineChart from '../Charts/General/RiskLineChart';
import RiskAppetite from '../Charts/General/RiskAppetite';
import RiskSummary from '../Charts/Department/RiskSummary';
import RiskSummaryReport from '../Charts/Department/RiskSummary_Report';
import TopRisks from '../Charts/Department/TopRisks';
import ActionStatus from '../Charts/Department/ActionStatus';

import Card7 from './Components/Card7';

import spinner from "../../assets/images/loader_blue.svg";
import spinner_white from "../../assets/images/loader_white.svg";

import mountain from "../../assets/images/mountain.jpeg";
import bluemountain from "../../assets/images/BlueMountain.jpg";
import page1chart from "../../assets/images/page1chart.png";
import page2chart from "../../assets/images/page2chart.png";
import page3chart from "../../assets/images/page3chart.png";
import page4chart from "../../assets/images/page4chart.png";
import page5chart from "../../assets/images/page5chart.png";

import ContentEditable from 'react-contenteditable'
import { getReports, getReport, createReport, deleteReport } from "../../store/actions/reportActions";



import { generatePDF } from '../../utils/pdf';
import { GeneratePDF } from '../../utils/pdfExport';
import { generateReportJSON } from "../../utils/reportUtils";

import "./ControlReport.css";


import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";

import moment from 'moment';



// const quillModules = {
//     toolbar: [
//       ["bold", "italic", "underline"], // Basic text styles
//       [{ size: ["small", false, "large"] }], // Font sizes
//       [{ align: [] }], // Text alignment
//       [{ list: "ordered" }, { list: "bullet" }], // Lists
//     ],
//   };



const getBadge = (value, type, data) => {
    let backgroundColor;
    if (value <= 2) {
        backgroundColor = 'bg-BADGE_1';
    } else if (value > 2 && value <= 6) {
        backgroundColor = 'bg-BADGE_2';
    } else if (value > 6 && value <= 12) {
        backgroundColor = 'bg-BADGE_3';
    } else {
        backgroundColor = 'bg-BADGE_4';
    }

    const financialHistory = data.financial_history ? data.financial_history[type] : null;
    const operationalHistory = data.operational_history ? data.operational_history[type] : null;
    const reputationalHistory = data.reputational_history ? data.reputational_history[type] : null;

    const financial = data.financial ? data.financial[type] : null;
    const operational = data.operational ? data.operational[type] : null;
    const reputational = data.reputational ? data.reputational[type] : null;

    let historyFinancial = financialHistory !== null ? (financialHistory - financial > 0 ? ArrowDownGreen : financialHistory - financial < 0 ? ArrowUpRed : Nill) : null;
    let historyOperational = operationalHistory !== null ? (operationalHistory - operational > 0 ? ArrowDownGreen : operationalHistory - operational < 0 ? ArrowUpRed : Nill) : null;
    let historyReputational = reputationalHistory !== null ? (reputationalHistory - reputational > 0 ? ArrowDownGreen : reputationalHistory - reputational < 0 ? ArrowUpRed : Nill) : null;

    return `
        <div class="badge ${backgroundColor} flex items-center justify-center text-center p-2 rounded-[5px] text-white whitespace-nowrap overflow-hidden text-ellipsis min-w-[55px]">
            <span>${value}</span>
            ${type === 'inherent' ? `<img src="${historyFinancial}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
            ${type === 'residual' ? `<img src="${historyOperational}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
            ${type === 'future' ? `<img src="${historyReputational}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
        </div>
    `;
}





const calculateFinancialLoss = (impact, levels) => {
    const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Find the corresponding riskImpact based on the impact value
    const riskImpact = levels.riskImpacts.find((item) => item.impact === impact);

    if (riskImpact) {
        // Calculate the average of financial_low and financial_high
        const average = (riskImpact.financial_low + riskImpact.financial_high) / 2;
        return formatNumber(Math.round(average)); // Round and format the number
    }

    // Default to 0 if no matching impact is found
    return formatNumber(0);
};


const ControlReport = ({ getControlsSearchFN, all_risk_controls, department_id, closeReport, getGeneralDashboardDataFN, general_dashboard_data, getDepartmentDashboardDataFN, getAllDepartmentsFN, all_departments, department_dashboard_data, getRisks_ReportFN, getAllRisks_ReportFN, risks_report, all_risks_report, getControls_ReportFN, risk_controls, getActions_ReportFN, risk_actions, getIncidents_ReportFN, getLevelsFN, risk_incidents, createReportFN, getReportFN, getReportsFN, deleteReportFN, levels, propData, is_new }) => {




    useEffect(() => {
        console.log("New Report?")
        if (is_new) {
            console.log("New Report!")
            const json = generateReportJSON(editableName, {
                page4subtitle4,
                page5subtitle3,
                table3data2,
                table4data,
            });
            console.log(json)
            createReportFN(json.editableName.title, json, 2)


            // Call the save function passed from the page
            //onSave(json);
        }
    }, [is_new]);
    // const [isEditing, setIsEditing] = useState(false);

    // const quillModules = isEditing
    //   ? {
    //       toolbar: [
    //         ["bold", "italic", "underline"],
    //         [{ size: ["small", false, "large"] }],
    //         [{ align: [] }],
    //         [{ list: "ordered" }, { list: "bullet" }],
    //       ],
    //     }
    //   : { toolbar: false }; // No toolbar when not editing

    const [activeBox, setActiveBox] = useState(null); // Tracks the active text box
    const editorRef = useRef(null);
    const [controls, setcontrols] = useState(null); // Tracks the active text box
    const [allControls, setAllControls] = useState(null);
    const [topControls, setTopControls] = useState(null);
    const [controls_by_department, set_controls_by_department] = useState(null);
    const [typecontrols_by_department, set_typecontrols_by_department] = useState(null);
    const [piecontrols_by_department, set_piecontrols_by_department] = useState(null);
    const [others, setOthers] = useState(null);
    const componentRef = useRef(null);
    ////console.log("levels report", levels);

    const getImpactDefinition = (impact) => {
        const impactDefinition = levels.riskImpacts.find(item => item.impact === impact);
        return impactDefinition || { operational: "N/A", financial: "N/A", reputational: "N/A" };
    };

    const getProbabilityDefinition = (probability) => {
        console.log("probability", probability)
        if (probability === "Almost Certain") {
            probability = "Almost certain"
        }
        const probabilityDefinition = levels.riskProbabilities.find(item => item.scale === probability);
        return probabilityDefinition || { scale: "N/A", controls: "N/A", frequency: "N/A" };
    };

    const getControls = () => {
        const controlsMap = new Map();

        risk_controls.forEach(risk => {
            risk.controls.forEach(control => {
                if (!controlsMap.has(control.controlID)) {
                    controlsMap.set(control.controlID, control);
                }
            });
        });

        return Array.from(controlsMap.values());
    };

    const getAllControls = () => {
        const departmentMap = new Map();
        console.log("Trying to get all controls")
        all_risk_controls.forEach(risk => {
            const deptId = risk.department.id;

            if (!departmentMap.has(deptId)) {
                departmentMap.set(deptId, new Map());
            }

            const controlsMap = departmentMap.get(deptId);
            //console.log("Processing control for Deparmtnet", deptId , " | ",risk.controls);
            (risk.controls || []).forEach(control => {
                //console.log("Processing control for Deparmtnet", deptId , " | ",control);
                if (!controlsMap.has(control.controlID)) {
                    controlsMap.set(control.controlID, control);
                }
            });
        });

        // Convert inner maps to arrays
        const finalMap = new Map();

        departmentMap.forEach((controlsMap, deptId) => {
            finalMap.set(deptId, Array.from(controlsMap.values()));
        });
        console.log(finalMap)
        return finalMap;
    };



    const getRisksByID = (risks, ID) => {
        return risks?.filter(item => item.DepartmentID === ID);
    };

    const getRisksByIDs = (risks, IDs) => {
        return risks?.filter(item => IDs.includes(item.DepartmentID));
    };

    const getPreventitve = (ID) => {
        if (!allControls) return [];
        let controls = allControls.get(ID)
        //console.log("Prevnetitve?" ,allControls, "|",controls)
        if (!controls) return [];
        return controls?.filter(control => control.controlType === "Preventive");
    };
    const getDetective = (ID) => {
        if (!allControls) return [];
        let controls = allControls.get(ID)
        if (!controls) return [];
        return controls?.filter(control => control.controlType === "Detective");
    };
    const getCorrective = (ID) => {
        if (!allControls) return [];
        let controls = allControls.get(ID)
        if (!controls) return [];
        return controls?.filter(control => control.controlType === "Corrective");
    };

    const getAll = (ID) => {
        if (!allControls) return [];
        let controls = allControls.get(ID)
        if (!controls) return [];
        return controls
    };

    const getAllControlsFlat = () => {
        const controlsArray = [];

        all_risk_controls.forEach(risk => {
            const deptId = risk.department.id;

            (risk.controls || []).forEach(control => {
                controlsArray.push({
                    ...control,            // keep all control fields
                    department_id: deptId,  // add department_id into control
                    department_name: risk.department.name
                });
            });
        });

        return controlsArray;
    };

    const getTop3Departments = (allControlsArray, currentDepartmentId) =>{
    
        const departmentMap = new Map();

        allControlsArray.forEach(control => {
            const deptId = control.department_id;


            if (deptId === null) {
                return;  
            }
            if (!departmentMap.has(deptId)) {
                departmentMap.set(deptId, []);
            }
            departmentMap.get(deptId).push(control);
        });


        const sortedDepartments = Array.from(departmentMap.entries())
            ?.filter(([deptId, _]) => deptId !== currentDepartmentId)
            .sort((a, b) => b[1]?.length - a[1]?.length);


        const finalMap = new Map();
        let others = [];
        let othersIds = [];


        //console.log("sortedDepartments", sortedDepartments)
        sortedDepartments.forEach(([deptId, controls], index) => {
            if (index < 3) {
                finalMap.set(deptId, controls);
            } else {
                others = others.concat(controls);
                othersIds.push(deptId);
            }
        });


        if (others?.length > 0) {
            finalMap.set("others", others);
        }

        if (departmentMap.has(currentDepartmentId)) {
            finalMap.set(currentDepartmentId, departmentMap.get(currentDepartmentId));
        }

        setOthers(othersIds)
        console.log("Final map:", finalMap, "othersIDs ", othersIds)
        return finalMap;
    }


    const getChartData = (TopRiskMap) => {
        let total = 0;
        TopRiskMap.forEach(controlList => {
            total += controlList?.length;
        });

        const result = Array.from(TopRiskMap.entries()).map(([deptId, controls]) => ({
            name: deptId === "others"? "Other" : controls[0].department_name,
            count: controls?.length,
            value: Math.round(controls?.length*100/ total),
            color: getColor(deptId, controls)
        }));

        return result
    }

    const getLineChartData = (TopRiskMap) => {
        const typeSums = {
            Preventive: { total: 0, count: 0 },
            Detective: { total: 0, count: 0 },
            Corrective: { total: 0, count: 0 },
        };

        TopRiskMap.forEach(controlList => {
            controlList.forEach(control => {
                const { controlType, efficiencyLevel  } = control;
                if (typeSums[controlType] && typeof efficiencyLevel  === 'number') {
                    typeSums[controlType].total += efficiencyLevel ;
                    typeSums[controlType].count += 1;
                }
            });
        });
        //console.log("typeSums", typeSums, "TopRiskMap", TopRiskMap)
        return [
            {
                name: "Preventive",
                value: typeSums.Preventive.count
                    ? Math.round(typeSums.Preventive.total / typeSums.Preventive.count)
                    : 0,
            },
            {
                name: "Detective",
                value: typeSums.Detective.count
                    ? Math.round(typeSums.Detective.total / typeSums.Detective.count)
                    : 0,
            },
            {
                name: "Corrective",
                value: typeSums.Corrective.count
                    ? Math.round(typeSums.Corrective.total / typeSums.Corrective.count)
                    : 0,
            },
        ];
    }

    const getPieChart = (TopRiskMap) => {
        const typeSums = {
            Preventive: { total: 0, count: 1 },
            Detective: { total: 0, count: 1  },
            Corrective: { total: 0, count: 1 },
        };

        TopRiskMap.forEach(controlList => {
            controlList.forEach(control => {
                const { controlType } = control;
                if (typeSums[controlType]) {
                    typeSums[controlType].total += 1 ;
                }
            });
        });
        console.log("PieSums", typeSums, "TopRiskMap", TopRiskMap)
        return [
            {
                name: "Preventive",
                value: typeSums.Preventive.count
                    ? Math.round(typeSums.Preventive.total / typeSums.Preventive.count)
                    : 0,
            },
            {
                name: "Detective",
                value: typeSums.Detective.count
                    ? Math.round(typeSums.Detective.total / typeSums.Detective.count)
                    : 0,
            },
            {
                name: "Corrective",
                value: typeSums.Corrective.count
                    ? Math.round(typeSums.Corrective.total / typeSums.Corrective.count)
                    : 0,
            },
        ];

    }

     const getColor = (deptId, controls) => {
        const name =  deptId === "others"? "Other" : controls[0].department_name
        switch(name){
            case "IT":
                return '#BB133E'             
            case "Finance":
                return '#F07167'
            case "Marketing":
                return '#F5B121'
            case "Operations":
                return '#FED9B7'
            case "Others":
                return '#09A6B0'
            default:
                return '#0056B3'
        }

    }

    const [language, setLanguage] = React.useState('en');

    const [loading, setLoading] = useState(true);
    const [parsing, setParsing] = useState(is_new);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        if (controls === null && risk_controls) {
            setcontrols(getControls())
        }
    }, []);

    useEffect(() => {
        if (allControls === null && all_risk_controls) {
            setAllControls(getAllControls())
        } else if (controls === null) {
            getControlsSearchFN(null)
        }
    }, [all_risk_controls]);


    useEffect(() => {
        if (topControls === null && allControls) {
            console.log("setting top 3 department")
            setTopControls(getTop3Departments(getAllControlsFlat(), department_id))
        }
    }, [allControls]);

    useEffect(() => {
        if (topControls) {
            set_controls_by_department(getChartData(topControls))
        }
    }, [topControls]);

    useEffect(() => {
        if (topControls) {
            set_typecontrols_by_department(getLineChartData(topControls))
        }
    }, [topControls]);

    useEffect(() => {
        if (topControls) {
            set_piecontrols_by_department(getPieChart(topControls))
        }
    }, [topControls]);
    

    useEffect(() => {
        if (propData) {
            loadReportJSON(propData);
            setParsing(true);
        }
    }, [propData]);

    const translations = {
        en: {
            title: "Q3 - REPORT",
            subtitle: "Comprehensive Insights: Identifying, Mitigating, and Strategically Managing the Top Threats to Secure Our Organization’s Future 01/10/2024",
            page1title: "1-EXECUTIVE SUMMARY",
            page1subtitle1: "Objectives",
            page1subtitle2: "",
            page1subtitle3: "The objectives of a Control Report include identifying and classifying control deficiencies, evaluating their potential impact and probability, tracking performance trends, proposing corrective actions, supporting operational decision-making, and ensuring compliance with internal policies and external regulations.",
            page1subtitle4: "Key Highlights",
            page1subtitle5: "Key highlights of this report include a thorough identification and categorization of current and potential control gaps across the organization, with in-depth assessments of each control's effectiveness and potential risks. We offer actionable recommendations to strengthen controls, reduce vulnerabilities, and enhance operational resilience. Control performance is continuously monitored to stay ahead of evolving challenges, with insights aligned to organizational goals to support informed decision-making. Our approach also emphasizes strict adherence to compliance and accountability, ensuring that all control activities are transparent, well-documented, and in line with regulatory requirements. This proactive and structured framework ensures the organization’s security and long-term operational success",
            page2title: "2-CONTROL ENVIRONMENT",
            page2subtitle1: "Control",
            page2subtitle2: "Key highlights of this report include a thorough identification and categorization of current and potential control gaps across the organization, with in-depth assessments of each control's effectiveness and potential risks. We offer actionable recommendations to strengthen controls, reduce vulnerabilities, and enhance operational resilience. Control performance is continuously monitored to stay ahead of evolving challenges, with insights aligned to organizational goals to support informed decision-making. Our approach also emphasizes strict adherence to compliance and accountability, ensuring that all control activities are transparent, well-documented, and in line with regulatory requirements. This proactive and structured framework ensures the organization’s security and long-term operational success.",
            page2subtitle3: "Geopolitical Uncertainty:",
            page2subtitle4: "In this section, we summarize the key risks within the department and assess how these risks impact our control environment. By identifying potential threats, we can understand their influence on the effectiveness of our internal controls and take appropriate actions to mitigate their impact.",
            page2subtitle5: "Regulatory and Compliance:",
            page2subtitle6: "Heightened regulatory scrutiny on data privacy, solvency requirements, and transparency in reinsurance transactions has necessitated increased compliance monitoring and reporting efforts.",
            page2subtitle7: "Cybersecurity Threats:",
            page2subtitle8: "Heightened regulatory scrutiny on data privacy, solvency requirements, and transparency in reinsurance transactions has necessitated increased compliance monitoring and reporting efforts",
            page3title: "3-CONTROL ACTIVITIES",
            page3subtitle1: "This section provides an overview of the inherent, residual, and future risk levels for financial, operational, and reputational risks. The primary key performance indicator (KPI) is the effectiveness of mitigation strategies, evaluated based on the ability to reduce inherent risks to future risk levels.",
            page3subtitle2: "In this section, we summarize the key risks within the department and assess how these risks impact our control environment. By identifying potential threats, we can understand their influence on the effectiveness of our internal controls and take appropriate actions to mitigate their impact.",
            page3subtitle3: "Risk appetite refers to the types and amount of risk, on a broad level, that the organization is willing to accept in pursuit of value. Neither appetite nor risk tolerance — the acceptable levels of variation in performance related to business objectives — is typically defined at the risk-specific level.",
            page3subtitle4: `<ul>        <li class="list-item">            <div class="circle averse"></div>            <strong>Averse: No Risk Appetite</strong> – Prioritizes security and stability, actively avoiding risks and favoring highly controlled environments.        </li>        <li class="list-item">            <div class="circle minimalist"></div>            <strong>Minimalist: Very Low Risk Appetite</strong> – Focuses on essential, low-impact risks, maintaining a lean approach to risk-taking, only as necessary.        </li>        <li class="list-item">            <div class="circle cautious"></div>            <strong>Cautious: Low Risk Appetite</strong> – Takes calculated risks with substantial preventive measures, preferring known outcomes with minimal uncertainty.        </li>        <li class="list-item">            <div class="circle open"></div>            <strong>Open: Moderate Risk Appetite</strong> – Willing to take some risks, considering innovative opportunities while balancing potential gains and losses.        </li>        <li class="list-item">            <div class="circle hungry"></div>            <strong>Hungry: High Risk Appetite</strong> – Actively seeks risk for the potential of high rewards, tolerating significant uncertainty and variability in outcomes.        </li>    </ul>`,
            page3subtitle5: "Risk Category Definition",
            page3subtitle6: `   <ul style="list-style-type: disc; padding-left: 20px; margin: 0;">        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Operational Risks:</strong> Potential disruption of business operations from plant shutdowns, suspensions, debarments, and loss of license.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Financial Risks:</strong> Internal and external costs associated with investigating and remediation (e.g., legal fees, consultants, investigators).        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Strategic Risks:</strong> Prohibition to add new customers, loss of license.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Compliance Risks:</strong> Report on regulatory compliance risks and any new requirements.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Reputational Risks:</strong> Effect of media coverage; damage to organization’s image/brand; and subsequent diminished attractiveness to current and potential future employees, business partners, vendors, and customers.        </li>    </ul>`,
            page4title: "4-PERFORMANCE",
            page4subtitle1: "Regulatory and Compliance:",
            page4subtitle2: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;">        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Inherent Risk:</strong> The level of risk that exists before any controls or mitigating actions are applied. It represents the raw, unaltered level of exposure to a particular threat or vulnerability.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Residual Risk:</strong> The level of risk that remains after controls and mitigating actions have been implemented. It reflects the organization's exposure after measures are taken to reduce or manage inherent risks.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Future Risk:</strong> The Future Risk or Target Risk Level refers to the level of risk that an organization aims to achieve or maintain in the future, considering upcoming changes, emerging trends, or potential unforeseen events.        </li>    </ul>    <p style="margin-bottom:20px"><strong>Key Distinction</strong></p>    <ul style="list-style-type: disc; padding-left: 20px;">        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Inherent Risk:</strong> Initial state of risk, pre-mitigation.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Residual Risk:</strong> Post-mitigation, the remaining risk.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Future Risk:</strong> Accepted risk level.        </li>    </ul>`,
            page4subtitle3: `<p style="font-weight:normal"><b>Likelihood of occurrence</b> refers to the probability or chance that a specific risk event will happen.</p>`,
            // page4subtitle4: `<table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal">        <thead style="background-color: #bb133e !important; color: black;">            <tr style="background-color: #bb133e !important; color: black;">                <th style="padding: 10px; border: 1px solid #ddd;">Likelihood</th>                <th style="padding: 10px; border: 1px solid #ddd;">Frequency</th>                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>            </tr>        </thead>        <tbody>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #336699;margin-right:10px"></div> Rare                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Less than once in 10 years</td>                <td style="padding: 10px;  border: 1px solid #ddd;">1</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <span style="width: 15px; height: 15px; border-radius: 50%; background-color: #66CCCC; margin-right: 10px;"></span> Unlikely                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once in 10 years</td>                <td style="padding: 10px; border: 1px solid #ddd;">2</td>            </tr>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <span style="width: 15px; height: 15px; border-radius: 50%; background-color: #FFCC99; margin-right: 10px;"></span> Possible                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once in 5 years</td>                <td style="padding: 10px; border: 1px solid #ddd;">3</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #CC6666; margin-right: 10px;"></div> Likely                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once per year</td>                <td style="padding: 10px; border: 1px solid #ddd;">4</td>            </tr>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #990033; margin-right: 10px;"></div> Almost certain                </td>                <td style="padding: 10px; border: 1px solid #ddd;">More than once per year</td>                <td style="padding: 10px; border: 1px solid #ddd;">5</td>            </tr>        </tbody>    </table>`,
            page5title: "5-KEY RISK CATEGORIES",
            page5subtitle1: "Regulatory and Compliance:",
            page5subtitle2: "Heightened regulatory scrutiny on data privacy, solvency requirements, and transparency in reinsurance transactions has necessitated increased compliance monitoring and reporting efforts.",
            //page5subtitle3: `<table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd;font-weight:normal">        <thead>            <tr style="background-color: #CC6666; color: black;">                <th style="padding: 10px; border: 1px solid #ddd;">Impact</th>                <th style="padding: 10px; border: 1px solid #ddd;">Operational</th>                <th style="padding: 10px; border: 1px solid #ddd;">Financial</th>                <th style="padding: 10px; border: 1px solid #ddd;">Reputational</th>                <th style="padding: 10px; border: 1px solid #ddd;">Strategic</th>                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>            </tr>        </thead>        <tbody>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #336699; margin-right: 10px;"></div>                        <strong>Insignificant</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in hours</td>                <td style="padding: 10px; border: 1px solid #ddd;">&lt;$100K</td>                <td style="padding: 10px; border: 1px solid #ddd;">No impact</td>                <td style="padding: 10px; border: 1px solid #ddd;">No impact</td>                <td style="padding: 10px; border: 1px solid #ddd;">1</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #66CCCC; margin-right: 10px;"></div>                        <strong>Minor</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in days</td>                <td style="padding: 10px; border: 1px solid #ddd;">$100K-$1M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Only company employees informed</td>                <td style="padding: 10px; border: 1px solid #ddd;">Minor impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">2</td>            </tr>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #FFCC99; margin-right: 10px;"></div>                        <strong>Moderate</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in one week</td>                <td style="padding: 10px; border: 1px solid #ddd;">$1M-$5M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Complaints from customer</td>                <td style="padding: 10px; border: 1px solid #ddd;">Major impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">3</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #CC6666; margin-right: 10px;"></div>                        <strong>Major</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Disruption over a week</td>                <td style="padding: 10px; border: 1px solid #ddd;">$5M-$15M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Reported in social and sectoral media</td>                <td style="padding: 10px; border: 1px solid #ddd;">Significant impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">4</td>            </tr>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #990033; margin-right: 10px;"></div>                        <strong>Catastrophe</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Disruption over a month</td>                <td style="padding: 10px; border: 1px solid #ddd;">&gt;$15M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Reported in mass media and administrative sanction</td>                <td style="padding: 10px; border: 1px solid #ddd;">Loss license</td>                <td style="padding: 10px; border: 1px solid #ddd;">5</td>            </tr>        </tbody>    </table>`,
            page5subtitle4: `The organization’s risk appetite would also be reflected in setting the values used in the anchor labels. An additional factor that may enhance the evaluation of severity is the localization or regionalization of the assessment. For multilocation and multinational organizations, risk may vary from one location or region to another, based on a wide variety of factors. `,
            page5subtitle5: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;font-weight:normal">        <li style="margin-bottom: 10px;">            <strong>Purpose:</strong> Visualize and categorize risks to prioritize which ones require more attention.        </li>        <li style="margin-bottom: 10px;">            <strong>Matrix Design:</strong> A typical matrix includes “Likelihood” on one axis and “Impact” on the other, with the resulting cells indicating a low, medium, or high overall risk.        </li>        <li style="margin-bottom: 10px;">            <strong>Prioritization:</strong> Risks in the high-likelihood, high-impact quadrant are top priorities, while low-likelihood, low-impact risks may require minimal action.        </li>    </ul>`,
            page6title: "6-COMPANY RISK LEVEL",
            page6subtitle1: "Performance",
            page6subtitle2: "This section presents the company’s general risk profile, including departmental risk counts, inherent risk levels, and risk appetite. A five-quarter time series shows inherent, residual, and future risk levels, helping track risk trends and assess alignment with the company's acceptable risk threshold across departments.",
            page6subtitle3: `<p style="font-weight:bold">Residual risk by departments:</p>
<p style="font-weight:normal">Residual risk is the amount of risk that remains after all risk controls and mitigation efforts have been implemented. In other words, it's the level of exposure that persists even after preventive, detective, and corrective measures are in place. We use residual risk as a KPI of risk awareness reflects how well employees and the organization recognize and address potential risks, highlighting a proactive approach to risk management.</p>
<p style="font-weight:normal">The charts indicate that the marketing and finance departments have higher levels of residual risk, highlighting the need for greater focus and improvement in these departments.</p>`,
            page6subtitle4: `<p style="font-weight:bold">General risk level by time:</p>
<p style="font-weight:normal">The above graph shows the average inherent risks, residual risks and future risks of the company in 5 quarters. During the reporting period, the inherent risks and residual risks of the company have decreased compared to the previous period. Our company has made serious progress in reducing risks.</p>`,
            page6subtitle5: `<p style="font-weight:bold">Risk appetite:</p>
<p style="font-weight:normal">Our company mostly operates with a minimalist risk appetite, prioritizing only essential and low-impact risks. This lean approach ensures that our risk-taking is deliberate and necessary, aligning with our core objectives and preserving organizational stability.</p>`,
            page7title: "7-DEPARTMENTAL DETAIL",
            page7subtitle1: "An overview of the general risk levels across the department is presented in this section, highlighting key statistics and assessments. A list of strategic risks that may impact long-term goals is also outlined, ensuring preparedness to address these challenges and maintain alignment with the broader business strategy.",
            page7subtitle2: "Risk by department",
            page7subtitle3: "This section provides an overview of the inherent, residual, and future risk levels for financial, operational, and reputational risks. The primary key performance indicator (KPI) is the effectiveness of mitigation strategies, evaluated based on the ability to reduce inherent risks to future risk levels. ",
            page8title: "8.LOW RISK",
            page8subtitle1: "8.1.Risk Assessment and Analysis",
            page8subtitle2: "This section comprises risks that have been mitigated to an acceptable level, based on their inherent, residual, and future risk evaluations. These risks, while previously higher in severity, have been reduced through effective controls and interventions.",
            page8subtitle3: "Ongoing monitoring ensures that these risks remain within acceptable thresholds, with measures in place to address any potential changes in the risk landscape.The goal is to maintain these risks at a manageable level, ensuring the continued stability and resilience of the organization.",
            page8subtitle4: "8.2. Control and Mitigations",
            page8subtitle5: "The strategies and measures implemented to address high-risk areas across financial, operational, and reputational risks are outlined. For each identified risk, the effectiveness of the controls in place to reduce their likelihood and impact has been assessed. Findings from the evaluation process are presented, along with recommendations for enhancing control measures to further mitigate high-risk levels.",
            page8subtitle6: "8.3. Action Plan and Timeline",
            page8subtitle7: "For risks that have been successfully reduced to acceptable levels, no further action is required at this stage. These risks are considered adequately mitigated, and efforts will focus on ongoing monitoring to ensure they remain within acceptable thresholds.",
            page9title: "9-HIGH RISK",
            page9subtitle1: "9.1.Risk Assessment and Analysis",
            page9subtitle2: "After implementing control measures, we have identified that some of certain financial, operational, and reputational risks still remain at a high-risk level. These risks are considered critical, requiring further attention and more robust mitigation strategies to prevent them from impacting the department’s objectives.",
            page9subtitle3: "Continuous monitoring and a proactive approach are essential to managing and reducing these risks to acceptable levels.",
            page9subtitle4: "9.2. Control and Mitigations",
            page9subtitle5: "The strategies and measures implemented to address high-risk areas across financial, operational, and reputational risks are outlined. For each identified risk, the effectiveness of the controls in place to reduce their likelihood and impact has been assessed. Findings from the evaluation process are presented, along with recommendations for enhancing control measures to further mitigate high-risk levels.",
            page9subtitle6: "9.3. Action Plan and Timeline",
            page9subtitle7: "All actions taken to address identified risks, along with their respective start and due times, are outlined. The progress of each action is tracked, with its status indicated as completed, in progress, or facing challenges. This section provides an overview of the timeline for each action, ensuring alignment of risk mitigation efforts with objectives and deadlines.",
            page9subtitle8: "By regularly updating the status of each action, we can ensure that necessary adjustments are made and maintain transparency in the execution of our risk management plan.",
            page10title: "10-INCIDENTS",
            page10subtitle1: "Incidents that occurred during this reporting period are shown in this section.",
            page11title: "CONCLUSION",
            page11subtitle1: `<p class="mb-4">      As part of our ongoing risk management efforts, the following provides a summary of the key findings, actions taken, and future steps for addressing financial, operational, and reputational risks.    </p>    <ol class="list-decimal list-inside space-y-3">      <li>        A thorough assessment of the organization’s financial, operational, and reputational risks has been completed, providing a clear view of the current risk landscape.      </li>      <li>        The effectiveness of implemented controls has been evaluated, showing significant reductions in risk levels. Several risks have successfully been mitigated from high to moderate or low levels, indicating that control measures have been largely effective.      </li>      <li>        Despite the progress, certain risks, particularly in operational and reputational areas, still require ongoing attention. These areas necessitate continuous monitoring and refinement of controls to align with the company’s risk tolerance and ensure long-term stability.      </li>      <li>        Specific recommendations have been provided to address the remaining high-risk areas. These suggestions focus on enhancing the current controls and implementing new measures where necessary to further reduce the likelihood and impact of these risks.      </li>      <li>        An action plan has been put in place, with clearly defined actions and timelines for each risk area. These actions aim to further mitigate the risks and ensure that they remain within acceptable levels.      </li>      <li>        Moving forward, the organization will continue to prioritize risk management, focusing on maintaining risks at acceptable levels. Any changes in the risk environment will be promptly addressed to ensure that the company’s risk exposure remains within acceptable boundaries.      </li>    </ol>`,
        }, tr: {
            title: "Q3 - RAPOR",
            subtitle: "Kapsamlı Risk İçgörüleri: Kurumumuzun Geleceğini Güvence Altına Almak için Tehditleri Belirleme, Azaltma ve Stratejik Yönetim 01/10/2024",
            page1title: "1-YÖNETİCİ ÖZETİ",
            page1subtitle1: "Hedefler",
            page1subtitle2: "Tanımlama, Değerlendirme, Azaltma ve İzleme – Stratejik Kararları Güçlendirme ve Dayanıklılığı Sağlama.",
            page1subtitle3: "ERM risk raporunun hedefleri arasında riskleri tanımlama ve kategorize etme, etki ve olasılıklarını değerlendirme, trendleri izleme, azaltma stratejileri önerme, stratejik karar vermeyi destekleme ve uyum ve hesap verebilirliği sağlama yer alır.",
            page1subtitle4: "Önemli Noktalar",
            page1subtitle5: "Bu raporun önemli noktaları arasında, kuruluş genelindeki mevcut ve gelişmekte olan risklerin kapsamlı bir şekilde tanımlanması ve kategorize edilmesi, her riskin potansiyel etkisinin ve olasılığının detaylı değerlendirmeleri yer almaktadır. Kırılganlığı azaltmayı ve dayanıklılığı artırmayı amaçlayan uygulanabilir azaltma stratejileri sunuyoruz. Gelişen zorluklarla başa çıkabilmek için risk maruziyetindeki eğilimler izleniyor ve içgörüler stratejik karar vermeyi desteklemek için kurumsal hedeflerle uyumlu hale getiriliyor. Ek olarak, yaklaşımımız tüm risk yönetimi faaliyetlerinin şeffaf, iyi belgelenmiş ve düzenleyici standartlarla uyumlu olmasını sağlayarak uyum ve hesap verebilirliği vurgulamaktadır. Bu proaktif ve yapılandırılmış yaklaşım, kuruluşu sürdürülebilir büyüme ve operasyonel güvenlik için konumlandırmaktadır.",

            page2title: "2-RİSK ORTAMI GENEL BAKIŞI",
            page2subtitle1: "İklim Değişikliği ve Felaket Maruziyeti:",
            page2subtitle2: "Sel, kasırga ve orman yangınları dahil olmak üzere aşırı hava koşulları beklenenden daha yüksek talep sıklığı ve şiddetine neden olduğundan, iklimle ilgili olaylar birincil endişe kaynağı olmaya devam ediyor. Artan iklim değişkenliği, felaket modelleme araçlarının doğruluğunu test etmeye ve kayıp kurtarma kaynaklarını zorlamaya devam ediyor. Parametrik sigorta ürünlerine yönelik artan talepler, daha uyarlanabilir sigorta çözümlerine doğru bir kayma olduğunu gösteriyor, ancak risk ölçümü ve fiyatlandırmada zorluklar da beraberinde geliyor.",
            page2subtitle3: "Jeopolitik Belirsizlik:",
            page2subtitle4: "Avrupa ve Kuzey Amerika dahil olmak üzere kilit pazarlardaki küresel siyasi gerilimler ve düzenleyici değişiklikler, çok uluslu reasürans programları için belirsizlik getirmiştir. Yaptırımlar, ticaret kısıtlamaları ve jeopolitik çatışmalar, enerji ve altyapı gibi belirli sektörler için reasürans bulunabilirliğini etkileyebilir. Düzenleyici çerçevelerin gelişmekte olduğu yeni pazarlar, farklı yargı alanlarında yeni uyum standartlarının karşılanması gerektiğinden hem büyüme fırsatları hem de artan düzenleyici risk sunmaktadır.",
            page2subtitle5: "Düzenleyici ve Uyum:",
            page2subtitle6: "Veri gizliliği, ödeme gücü gereksinimleri ve reasürans işlemlerinde şeffaflık konusundaki artan düzenleyici inceleme, artan uyum izleme ve raporlama çabalarını gerekli kılmıştır.",
            page2subtitle7: "Siber Güvenlik Tehditleri:",
            page2subtitle8: "Siber saldırılardaki artan karmaşıklık, operasyonel süreklilik, müşteri veri koruması ve finansal istikrar için önemli bir risk oluşturuyor. Siber riskler sadece iç operasyonlar için değil, siber reasürans ürünlerine olan talep arttıkça müşteri portföyleri için de bir endişe kaynağıdır.",

            page3title: "3-STRATEJİ VE HEDEF",
            page3subtitle1: "Risk İştahı, Risk Kategorisi",
            page3subtitle2: "Risk İştahı Tanımı",
            page3subtitle3: "Risk iştahı, kuruluşun değer yaratma arayışında geniş düzeyde kabul etmeye istekli olduğu risk türlerini ve miktarını ifade eder. Ne iştah ne de risk toleransı — iş hedefleriyle ilgili performanstaki kabul edilebilir değişim seviyeleri — tipik olarak riske özgü düzeyde tanımlanmaz.",
            page3subtitle4: `<ul>
                <li class="list-item">
                    <div class="circle averse"></div>
                    <strong>Kaçınan: Risk İştahı Yok</strong> – Güvenlik ve istikrarı önceliklendirir, risklerden aktif olarak kaçınır ve yüksek kontrollü ortamları tercih eder.
                </li>
                <li class="list-item">
                    <div class="circle minimalist"></div>
                    <strong>Minimalist: Çok Düşük Risk İştahı</strong> – Sadece gerekli olduğunda, temel, düşük etkili risklere odaklanır, risk almada yalın bir yaklaşım sürdürür.
                </li>
                <li class="list-item">
                    <div class="circle cautious"></div>
                    <strong>Temkinli: Düşük Risk İştahı</strong> – Önemli önleyici tedbirlerle hesaplanmış riskler alır, minimum belirsizlikle bilinen sonuçları tercih eder.
                </li>
                <li class="list-item">
                    <div class="circle open"></div>
                    <strong>Açık: Orta Risk İştahı</strong> – Potansiyel kazanç ve kayıpları dengelerken yenilikçi fırsatları değerlendirerek bazı riskleri almaya isteklidir.
                </li>
                <li class="list-item">
                    <div class="circle hungry"></div>
                    <strong>Hırslı: Yüksek Risk İştahı</strong> – Yüksek ödüller potansiyeli için aktif olarak risk arar, sonuçlarda önemli belirsizlik ve değişkenliği tolere eder.
                </li>
            </ul>`,
            page3subtitle5: "Risk Kategorisi Tanımı",
            page3subtitle6: `<ul style="list-style-type: disc; padding-left: 20px; margin: 0;">
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Operasyonel Riskler:</strong> Tesis kapanmaları, askıya almalar, yasaklamalar ve lisans kaybından kaynaklanan potansiyel iş operasyonları kesintisi.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Finansal Riskler:</strong> Soruşturma ve iyileştirme ile ilgili iç ve dış maliyetler (örn. yasal ücretler, danışmanlar, araştırmacılar).
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Stratejik Riskler:</strong> Yeni müşteri ekleme yasağı, lisans kaybı.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Uyum Riskleri:</strong> Düzenleyici uyum riskleri ve yeni gereksinimleri raporlama.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>İtibar Riskleri:</strong> Medya kapsamının etkisi; kuruluşun imajına/markasına zarar; ve sonuç olarak mevcut ve potansiyel gelecekteki çalışanlar, iş ortakları, tedarikçiler ve müşteriler için azalan çekicilik.
                </li>
            </ul>`,

            page4title: "4-PERFORMANS",
            page4subtitle1: "Risk yöntemi ve şiddeti",
            page4subtitle2: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;">
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Doğal Risk:</strong> Herhangi bir kontrol veya azaltıcı eylem uygulanmadan önce var olan risk seviyesi. Belirli bir tehdit veya güvenlik açığına karşı ham, değiştirilmemiş maruziyet seviyesini temsil eder.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Kalıntı Risk:</strong> Kontroller ve azaltıcı eylemler uygulandıktan sonra kalan risk seviyesi. Doğal riskleri azaltmak veya yönetmek için önlemler alındıktan sonra kuruluşun maruziyetini yansıtır.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Gelecek Risk:</strong> Gelecek Risk veya Hedef Risk Seviyesi, bir kuruluşun gelecekte yaklaşan değişiklikleri, ortaya çıkan trendleri veya potansiyel öngörülemeyen olayları göz önünde bulundurarak ulaşmayı veya sürdürmeyi amaçladığı risk seviyesini ifade eder.
                </li>
            </ul>
            <p style="margin-bottom:20px"><strong>Temel Ayrım</strong></p>
            <ul style="list-style-type: disc; padding-left: 20px;">
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Doğal Risk:</strong> Azaltma öncesi başlangıç risk durumu.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Kalıntı Risk:</strong> Azaltma sonrası kalan risk.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Gelecek Risk:</strong> Kabul edilen risk seviyesi.
                </li>
            </ul>`,
            page4subtitle3: `<p style="font-weight:normal"><b>Gerçekleşme olasılığı</b> belirli bir risk olayının gerçekleşme olasılığını veya şansını ifade eder.</p>`,

            page5title: "5-TEMEL RİSK KATEGORİLERİ",
            page5subtitle1: "Risk şiddeti",
            page5subtitle2: "Operasyonel, Finansal, İtibar Riskleri Etkisi",
            page5subtitle4: "Kuruluşun risk iştahı, çapa etiketlerinde kullanılan değerlerin belirlenmesinde de yansıtılacaktır. Şiddet değerlendirmesini geliştirebilecek ek bir faktör, değerlendirmenin yerelleştirilmesi veya bölgeselleştirilmesidir. Çok lokasyonlu ve çok uluslu kuruluşlar için risk, çok çeşitli faktörlere bağlı olarak bir lokasyondan veya bölgeden diğerine değişebilir.",
            page5subtitle5: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;font-weight:normal">
                <li style="margin-bottom: 10px;">
                    <strong>Amaç:</strong> Hangi risklerin daha fazla dikkat gerektirdiğini önceliklendirmek için riskleri görselleştirme ve kategorize etme.
                </li>
                <li style="margin-bottom: 10px;">
                    <strong>Matris Tasarımı:</strong> Tipik bir matris, bir eksende "Olasılık" ve diğerinde "Etki" içerir, sonuçta oluşan hücreler düşük, orta veya yüksek genel riski gösterir.
                </li>
                <li style="margin-bottom: 10px;">
                    <strong>Önceliklendirme:</strong> Yüksek olasılık, yüksek etki çeyreğindeki riskler en öncelikli iken, düşük olasılık, düşük etki riskleri minimal eylem gerektirebilir.
                </li>
            </ul>`,

            page6title: "6-ŞİRKET RİSK SEVİYESİ",
            page6subtitle1: "Performans",
            page6subtitle2: "Bu bölüm, departmansal risk sayıları, doğal risk seviyeleri ve risk iştahı dahil olmak üzere şirketin genel risk profilini sunar. Beş çeyreklik bir zaman serisi, doğal, kalıntı ve gelecek risk seviyelerini göstererek risk trendlerini takip etmeye ve departmanlar genelinde şirketin kabul edilebilir risk eşiği ile uyumunu değerlendirmeye yardımcı olur.",
            page6subtitle3: `<p style="font-weight:bold">Departmanlara göre kalıntı risk:</p>
        <p style="font-weight:normal">Kalıntı risk, tüm risk kontrolleri ve azaltma çabaları uygulandıktan sonra kalan risk miktarıdır. Başka bir deyişle, önleyici, tespit edici ve düzeltici önlemler alındıktan sonra bile devam eden maruziyet seviyesidir. Risk farkındalığının bir KPI'sı olarak kalıntı riski kullanıyoruz, çalışanların ve kuruluşun potansiyel riskleri nasıl tanıdığını ve ele aldığını, risk yönetimine proaktif bir yaklaşımı vurgulayarak yansıtır.</p>
        <p style="font-weight:normal">Grafikler, pazarlama ve finans departmanlarının daha yüksek kalıntı risk seviyelerine sahip olduğunu gösteriyor, bu departmanlarda daha fazla odaklanma ve iyileştirme ihtiyacını vurguluyor.</p>`,
            page6subtitle4: `<p style="font-weight:bold">Zamana göre genel risk seviyesi:</p>
        <p style="font-weight:normal">Yukarıdaki grafik, şirketin 5 çeyrekteki ortalama doğal riskleri, kalıntı riskleri ve gelecek risklerini göstermektedir. Raporlama döneminde, şirketin doğal riskleri ve kalıntı riskleri önceki döneme göre azalmıştır. Şirketimiz riskleri azaltma konusunda ciddi ilerleme kaydetmiştir.</p>`,
            page6subtitle5: `<p style="font-weight:bold">Risk iştahı:</p>
        <p style="font-weight:normal">Şirketimiz çoğunlukla minimalist bir risk iştahıyla çalışır, sadece temel ve düşük etkili risklere öncelik verir. Bu yalın yaklaşım, risk almamızın bilinçli ve gerekli olmasını sağlar, temel hedeflerimizle uyumlu olur ve kurumsal istikrarı korur.</p>`,

            page7title: "7-DEPARTMAN DETAYI",
            page7subtitle1: "Bu bölümde, departman genelindeki genel risk seviyelerine ilişkin bir genel bakış sunularak, temel istatistikler ve değerlendirmeler vurgulanmaktadır. Uzun vadeli hedefleri etkileyebilecek stratejik risklerin bir listesi de bu zorlukları ele almaya hazırlıklı olmak ve daha geniş iş stratejisiyle uyumu sürdürmek için ana hatlarıyla belirtilmiştir.",
            page7subtitle2: "Departmana göre risk",
            page7subtitle3: "Bu bölüm, finansal, operasyonel ve itibar riskleri için doğal, kalıntı ve gelecek risk seviyelerine genel bir bakış sağlar. Temel performans göstergesi (KPI), doğal riskleri gelecek risk seviyelerine düşürme yeteneğine dayalı olarak değerlendirilen azaltma stratejilerinin etkinliğidir.",

            page8title: "8-DÜŞÜK RİSK",
            page8subtitle1: "8.1.Risk Değerlendirmesi ve Analizi",
            page8subtitle2: "Bu bölüm, doğal, kalıntı ve gelecek risk değerlendirmelerine dayanarak kabul edilebilir bir seviyeye indirilmiş riskleri içerir. Daha önce şiddeti daha yüksek olan bu riskler, etkili kontroller ve müdahaleler yoluyla azaltılmıştır.",
            page8subtitle3: "Sürekli izleme, bu risklerin kabul edilebilir eşikler içinde kalmasını sağlar, risk ortamındaki potansiyel değişiklikleri ele almak için önlemler mevcuttur. Amaç, bu riskleri yönetilebilir bir seviyede tutarak, kuruluşun sürekli istikrarını ve dayanıklılığını sağlamaktır.",
            page8subtitle4: "8.2. Kontrol ve Azaltmalar",
            page8subtitle5: "Finansal, operasyonel ve itibar riskleri genelinde yüksek riskli alanları ele almak için uygulanan stratejiler ve önlemler ana hatlarıyla belirtilmiştir. Tanımlanan her risk için, olasılıklarını ve etkilerini azaltmak üzere mevcut kontrollerin etkinliği değerlendirilmiştir. Değerlendirme sürecinden elde edilen bulgular, yüksek risk seviyelerini daha da azaltmak için kontrol önlemlerini geliştirmeye yönelik önerilerle birlikte sunulmuştur.",
            page8subtitle6: "8.3. Eylem Planı ve Zaman Çizelgesi",
            page8subtitle7: "Kabul edilebilir seviyelere başarıyla indirilen riskler için bu aşamada başka bir eylem gerekmemektedir. Bu riskler yeterince azaltılmış kabul edilir ve çabalar, kabul edilebilir eşikler içinde kalmalarını sağlamak için sürekli izlemeye odaklanacaktır.",

            page9title: "9-YÜKSEK RİSK",
            page9subtitle1: "9.1.Risk Değerlendirmesi ve Analizi",
            page9subtitle2: "Kontrol önlemleri uygulandıktan sonra, bazı finansal, operasyonel ve itibar risklerinin hala yüksek risk seviyesinde kaldığını tespit ettik. Bu riskler kritik kabul edilir, departmanın hedeflerini etkilemelerini önlemek için daha fazla dikkat ve daha sağlam azaltma stratejileri gerektirir.",
            page9subtitle3: "Bu riskleri yönetmek ve kabul edilebilir seviyelere indirmek için sürekli izleme ve proaktif bir yaklaşım esastır.",
            page9subtitle4: "9.2. Kontrol ve Azaltmalar",
            page9subtitle5: "Finansal, operasyonel ve itibar riskleri genelinde yüksek riskli alanları ele almak için uygulanan stratejiler ve önlemler ana hatlarıyla belirtilmiştir. Tanımlanan her risk için, olasılıklarını ve etkilerini azaltmak üzere mevcut kontrollerin etkinliği değerlendirilmiştir. Değerlendirme sürecinden elde edilen bulgular, yüksek risk seviyelerini daha da azaltmak için kontrol önlemlerini geliştirmeye yönelik önerilerle birlikte sunulmuştur.",
            page9subtitle6: "9.3. Eylem Planı ve Zaman Çizelgesi",
            page9subtitle7: "Tanımlanan riskleri ele almak için alınan tüm eylemler, ilgili başlangıç ve bitiş süreleriyle birlikte ana hatlarıyla belirtilmiştir. Her eylemin ilerlemesi izlenir, durumu tamamlandı, devam ediyor veya zorluklar yaşıyor olarak belirtilir. Bu bölüm, risk azaltma çabalarının hedefler ve son tarihlerle uyumunu sağlayarak her eylem için zaman çizelgesine genel bir bakış sağlar.",
            page9subtitle8: "Her eylemin durumunu düzenli olarak güncelleyerek, gerekli ayarlamaların yapıldığından emin olabilir ve risk yönetim planımızın uygulanmasında şeffaflığı koruyabiliriz.",

            page10title: "10-OLAYLAR",
            page10subtitle1: "Bu raporlama döneminde gerçekleşen olaylar bu bölümde gösterilmektedir.",

            page11title: "SONUÇ",
            page11subtitle1: `<p class="mb-4">Süregelen risk yönetimi çabalarımızın bir parçası olarak, aşağıda finansal, operasyonel ve itibar risklerini ele almak için temel bulgular, alınan eylemler ve gelecek adımların bir özeti sunulmaktadır.</p>
            <ol class="list-decimal list-inside space-y-3">
              <li>Kuruluşun finansal, operasyonel ve itibar risklerinin kapsamlı bir değerlendirmesi tamamlanmış, mevcut risk ortamının net bir görünümü sağlanmıştır.</li>
              <li>Uygulanan kontrollerin etkinliği değerlendirilmiş, risk seviyelerinde önemli azalmalar görülmüştür. Birçok risk başarıyla yüksek seviyeden orta veya düşük seviyelere indirilmiş, bu da kontrol önlemlerinin büyük ölçüde etkili olduğunu göstermektedir.</li>
              <li>Kaydedilen ilerlemeye rağmen, özellikle operasyonel ve itibar alanlarındaki bazı riskler sürekli dikkat gerektirmektedir. Bu alanlar, şirketin risk toleransı ile uyumlu olmak ve uzun vadeli istikrarı sağlamak için kontrollerin sürekli izlenmesini ve iyileştirilmesini gerektirmektedir.</li>
              <li>Kalan yüksek riskli alanları ele almak için özel öneriler sunulmuştur. Bu öneriler, bu risklerin olasılığını ve etkisini daha da azaltmak için mevcut kontrolleri geliştirmeye ve gerektiğinde yeni önlemler uygulamaya odaklanmaktadır.</li>
              <li>Her risk alanı için açıkça tanımlanmış eylemler ve zaman çizelgeleri içeren bir eylem planı oluşturulmuştur. Bu eylemler, riskleri daha da azaltmayı ve kabul edilebilir seviyelerde kalmalarını sağlamayı amaçlamaktadır.</li>
              <li>İleriye dönük olarak, kuruluş risk yönetimine öncelik vermeye, riskleri kabul edilebilir seviyelerde tutmaya odaklanmaya devam edecektir. Risk ortamındaki herhangi bir değişiklik, şirketin risk maruziyetinin kabul edilebilir sınırlar içinde kalmasını sağlamak için hızla ele alınacaktır.</li>
            </ol>`
        }
    };

    const [updateTrigger, setUpdateTrigger] = React.useState(0);

    const editableName = React.useRef(JSON.parse(JSON.stringify(translations[language])));

    React.useEffect(() => {
        if (is_new === true) {
            editableName.current = translations[language];
            // Force a re-render by updating trigger
            setUpdateTrigger(prev => prev + 1);
        }
    }, [language]);


    const [page4subtitle4, setPage4subtitle4] = React.useState("");
    const [page5subtitle3, setPage5subtitle3] = React.useState("");


    // Add language selector if not already present
    const handleLanguageChange = (e) => {
        //console.log(`changed language to ${e.target.value}`);
        setLanguage(e.target.value);
    };


    React.useEffect(() => {
        if (levels?.riskProbabilities) {
            const backgroundColors = ['#990033', '#CC6666', '#FFCC99', '#66CCCC', '#336699'];

            const tableRows = levels.riskProbabilities
                .map((item, index) => `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'transparent'};">
                            <td style="padding: 10px; width:618px; border: 1px solid #ddd; display: flex; align-items: center; font-size: 12px;">
                                <div style="width: 15px; height: 15px; border-radius: 50%; background-color: ${backgroundColors[item.id - 1]}; margin-right: 10px;"></div>
                                ${item.scale}
                            </td>
                            <td style="padding: 10px; border: 1px solid #ddd;">${item.frequency}</td>
                            <td style="padding: 10px; border: 1px solid #ddd;">${item.id}</td>
                        </tr>
                    `)
                .join('');

            const tableHTML = language === "en" ? `
                    <table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal; font-size: 12px;">
                        <thead style="background-color: #bb133e !important; color: black;">
                            <tr style="background-color: #bb133e !important; color: black;">
                                <th style="padding: 10px; border: 1px solid #ddd;">Likelihood</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Frequency</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                ` : `
                    <table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal; font-size: 12px;">
                        <thead style="background-color: #bb133e !important; color: black;">
                            <tr style="background-color: #bb133e !important; color: black;">
                                <th style="padding: 10px; border: 1px solid #ddd;">Olasılık</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Frekans</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Skor</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                `;

            setPage4subtitle4(tableHTML); // Set the state with the generated HTML
        }
    }, [levels, language]);

    React.useEffect(() => {
        if (levels?.riskImpacts) {
            const backgroundColors = ['#336699', '#66CCCC', '#FFCC99', '#CC6666', '#990033'];

            const tableRows = levels.riskImpacts
                .map((item, index) => `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};">
                            <td style="padding: 6px; border: 1px solid #ddd; text-align: left; vertical-align: top; font-size: 12px; width: 20%;">
                                <div style="display: flex; align-items: center;">
                                    <div style="width: 12px; height: 12px; border-radius: 50%; background-color: ${backgroundColors[item.id - 1]}; margin-right: 6px;"></div>
                                    <strong>${item.impact}</strong>
                                </div>
                            </td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.operational}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">$${item.financial_low} - $${item.financial_high}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.reputational}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.strategic}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; text-align: center; vertical-align: top; font-size: 12px; width: 10%;">${item.id}</td>
                        </tr>
                    `)
                .join('');

            const tableHTML = language === "en" ? `
                    <table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd; font-weight: normal; table-layout: fixed; font-size: 12px;">
                        <thead style="background-color: #CC6666; color: black;">
                            <tr>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Impact</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Operational</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Financial</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Reputational</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Strategic</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: center; font-size: 12px; width: 10%;">Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                ` : `
                    <table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd; font-weight: normal; table-layout: fixed; font-size: 12px;">
                        <thead style="background-color: #CC6666; color: black;">
                            <tr>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Etkilenme</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Operasyonel</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Finansal</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">İtibar</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Stratejik</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: center; font-size: 12px; width: 10%;">Skor</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                `;

            setPage5subtitle3(tableHTML); // Set the state with the generated HTML
        }
    }, [levels]);


    const total_risks = general_dashboard_data?.risk_level_by_department?.map(department => department.totalRisks).reduce((a, b) => a + b, 0) || 0;
    //const top_department_names = general_dashboard_data?.risk_level_by_department?.[0]?.name || "N/D";

    // const { toPDF, targetRef } = usePDF({ filename: 'report.pdf' });

    const [table1data, setTable1data] = React.useState("");
    const [table1data2, setTable1data2] = React.useState("");

    const [table2data1, setTable2data] = React.useState("");
    const [table2data2, setTable2data2] = React.useState("");
    const [table3data1, setTable3data] = React.useState("");
    const [table3data2, setTable3data2] = React.useState("");
    const [table4data, setTable4data] = React.useState("");




    React.useEffect(() => {


        getGeneralDashboardDataFN();
        getAllDepartmentsFN();
        getDepartmentDashboardDataFN(department_id);
        getRisks_ReportFN(department_id);
        getAllRisks_ReportFN();
        getControls_ReportFN(department_id);
        getActions_ReportFN(department_id);
        getIncidents_ReportFN(department_id);
        getLevelsFN();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //////console.log(activeDepartment);
    React.useEffect(() => {
        if (general_dashboard_data) {

            // should be switched to last use effect
            setTimeout(() => {
                setLoading(false);
            }, 1200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [general_dashboard_data]);

    React.useEffect(() => {
        if (department_dashboard_data) {
            ////console.log(department_dashboard_data);
            setTimeout(() => {
                setLoading(false);
            }, 1200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department_dashboard_data]);


    ////console.log("Risk report: ", risks_report);
    React.useEffect(() => {
        console.log("report risk: ", all_departments);
        if (all_departments) {
            // ////console.log(risks_report);

            let table1data = language === "en" ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Department</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Risk</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Preventive Controls</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Detective Controls</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Corrective Controls</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Total Controls</th>
          <th class="border border-gray-300 px-4 py-2 text-left fixed-height report-th">Controls Per Risk</th>
        </tr>
      </thead>
      <tbody>` : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Başlığı</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Sahibi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th" style="width: 5000px;">Risk Tanımı</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Stratejik Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Seviyesi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Olasılık</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Finansal Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Operasyonel Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">İtibar Etkisi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Finansal Risk</th>
          <th class="border border-gray-300 px-2 py-2 text-left report-th">Operasyonel Risk</th>
          <th class="border border-gray-300 px-1 py-2 text-left report-th">İtibar Riski</th>
        </tr>
      </thead>
      <tbody>`;

            let table1data2 = table1data;
            console.log("allControls before loop:", allControls);
            all_departments.forEach(department => {
                if (topControls && (!topControls.has(department.department_id))) {
                    return;
                }
                table1data += `
                <!-- First Row: Contains the Data -->
                <tr class="bg-white text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height report-td">${department.name}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getRisksByID(all_risks_report, department.department_id)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getPreventitve(department.department_id)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getDetective(department.department_id)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getCorrective(department.department_id)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getAll(department.department_id)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${(getAll(department.department_id)?.length / getRisksByID(all_risks_report, department.department_id)?.length).toFixed(2)}</td>
                    
                </tr>`;
            });

            if (topControls && all_departments.length > 3) {

                table1data += `
                <!-- First Row: Contains the Data -->
                <tr class="bg-white text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height report-td">Others</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${getRisksByIDs(all_risks_report, others)?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${topControls.get("others")?.filter(control => control.controlType === "Preventive")?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${topControls.get("others")?.filter(control => control.controlType === "Detective")?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${topControls.get("others")?.filter(control => control.controlType === "Corrective")?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${topControls.get("others")?.length}</td>
                    <td class="border-l border-gray-300 px-4 py-1 no-bottom-border fixed-height text-center report-td">${(topControls.get("others")?.length / getRisksByIDs(all_risks_report, others)?.length).toFixed(2)}</td>
                    
                </tr> `;
            }

            table1data += `</tbody>
            
    </table>`;

            table1data2 += `</tbody>
            
    </table>`;


            setTable1data(table1data);
            setTable1data2(table1data2);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risks_report, language]);

    ////console.log("report controls", risk_controls);

    React.useEffect(() => {
        if (risk_controls) {
            let table2data1 = language === 'en' ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Title</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Owner</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th" style="width: 5000px;">Control Definition</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Type</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Efficiency</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Finding</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Recommendation</th>
            </tr>
          </thead>
          <tbody>` : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Başlığı</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Sahibi</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th" style="width: 5000px;">Kontrol Tanımı</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Tipi</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Verimliliği</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Bulgu</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Öneri</th>
            </tr>
          </thead>
          <tbody>`;

            let table2data2 = table2data1;
            // Iterate through each risk
            console.log("risk_controls", risk_controls)
            risk_controls.forEach((control, controlIndex) => {
                if (control.residualScores.financial <= 6 && control.residualScores.operational <= 6 && control.residualScores.reputational <= 6) {
                    // First row with full data
                    const filteredControls = control.controls?.filter(c => (c.secondLine && c.secondLine !== 0));
                    const firstRow = `
                    <tr class="bg-white text-gray-800">
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.riskId}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.title}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.owner.firstName} ${control.owner.lastName}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${filteredControls[0]?.controlDefinition || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${filteredControls[0]?.controlType || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white text-[#3b3b3b]">
                            ${filteredControls[0]?.efficiencyLevel > 50 || !filteredControls[0]?.efficiencyLevel
                            ? "<i class='fas fa-thumbs-up'></i>"
                            : "<i class='fas fa-frown'></i>"
                        }
                        </td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${filteredControls[0]?.secondFindings || "No findings were identified"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${filteredControls[0]?.secondRecommendations || "No recommendations are required"}</td>
                    </tr>`;

                    table2data1 += firstRow;

                    // Remaining rows for controls
                    for (let i = 1; i <filteredControls?.length; i++) {
                        const additionalRow = `
                        <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border border-gray-300 px-4 py-2">${filteredControls[i]?.controlDefinition || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2">${filteredControls[i]?.controlType || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2 text-[#3b3b3b]">
                                ${filteredControls[i]?.efficiencyLevel > 75 || !filteredControls[i]?.efficiencyLevel
                                ? "<i class='fas fa-thumbs-up'></i>"
                                : "<i class='fas fa-frown'></i>"
                            }
                            </td>
                            <td class="border border-gray-300 px-4 py-2">${filteredControls[i]?.secondFindings || "No findings were identified"}</td>
                            <td class="border border-gray-300 px-4 py-2">${filteredControls[i]?.secondRecommendations || "No recommendations are required"}</td>
                        </tr>`;
                        table2data1 += additionalRow;
                    }
                } else {
                    const firstRow = `
            <tr class="bg-white text-gray-800">
                <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.riskId}</td>
                <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.title}</td>
                <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${control.owner.firstName} ${control.owner.lastName}</td>
                <td class="border border-gray-300 px-4 py-2 bg-white">${control.controls[0]?.controlDefinition || "N/A"}</td>
                <td class="border border-gray-300 px-4 py-2 bg-white">${control.controls[0]?.controlType || "N/A"}</td>
                <td class="border border-gray-300 px-4 py-2 bg-white text-[#3b3b3b]">
                    ${control.controls[0]?.efficiencyLevel > 50 || !control.controls[0]?.efficiencyLevel
                            ? "<i class='fas fa-thumbs-up'></i>"
                            : "<i class='fas fa-frown'></i>"
                        }
                </td>
                <td class="border border-gray-300 px-4 py-2 bg-white">${control.controls[0]?.finding || "No findings were identified"}</td>
                <td class="border border-gray-300 px-4 py-2 bg-white">${control.controls[0]?.recommendation || "No recommendations are required"}</td>
            </tr>`;

                    table2data2 += firstRow;

                    // Remaining rows for controls
                    for (let i = 1; i < control.controls?.length; i++) {
                        const additionalRow = `
                <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border border-gray-300 px-4 py-2">${control.controls[i]?.controlDefinition || "N/A"}</td>
                    <td class="border border-gray-300 px-4 py-2">${control.controls[i]?.controlType || "N/A"}</td>
                    <td class="border border-gray-300 px-4 py-2 text-[#3b3b3b]">
                        ${control.controls[i]?.efficiencyLevel > 75 || !control.controls[i]?.efficiencyLevel
                                ? "<i class='fas fa-thumbs-up'></i>"
                                : "<i class='fas fa-frown'></i>"
                            }
                    </td>
                    <td class="border border-gray-300 px-4 py-2">${control.controls[i]?.finding || "No findings were identified"}</td>
                    <td class="border border-gray-300 px-4 py-2">${control.controls[i]?.recommendation || "No recommendations are required"}</td>
                </tr>`;
                        table2data2 += additionalRow;
                    }

                }

            });

            table2data1 += `</tbody>
        </table>`;

            table2data2 += `</tbody>
        </table>`;

            setTable2data(table2data1);
            setTable2data2(table2data2);
        }
    }, [risk_controls, language]);


    ////console.log("risk actions report: ", risk_actions);


    React.useEffect(() => {
        if (risk_actions) {
            let table3data1 = language === 'en' ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Title</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Owner</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th" style="width: 5000px;">Action Definition</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Start</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Due</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">State</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Explanation</th>
            </tr>
          </thead>
          <tbody>` : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Başlığı</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Sahibi</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th" style="width: 5000px;">Aksiyon Tanımı</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Başlangıç</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Bitiş</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Durum</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Açıklama</th>
            </tr>
          </thead>
          <tbody>`;

            let table3data2 = table3data1;

            // Iterate through each risk action
            risk_actions.forEach((action) => {
                if (action.residualScores.financial <= 6 && action.residualScores.operational <= 6 && action.residualScores.reputational <= 6) {
                    const firstRow = `
                    <tr class="bg-white text-gray-800">
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.riskId}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.title}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.owner.firstName} ${action.owner.lastName}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${action.actions[0]?.details || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${moment(action.actions[0]?.startDate).format("DD/MM/YYYY") || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${moment(action.actions[0]?.endDate).format("DD/MM/YYYY") || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white text-[#3b3b3b]">
                            ${action.actions[0]?.progress === "Problem"
                            ? "<i class='fas fa-frown'></i>"
                            : "<i class='fas fa-thumbs-up'></i>"
                        }
                        </td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${action.actions[0]?.progress === "Problem" ? action.actions[0]?.problem : action.actions[0]?.progress || "N/A"}</td>
                    </tr>`;
                    if (action.actions[0]?.details) {
                        table3data1 += firstRow;
                    }
                    // table3data1 += firstRow;

                    // Remaining rows for actions
                    for (let i = 1; i < action.actions?.length; i++) {
                        const additionalRow = `
                        <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border border-gray-300 px-4 py-2">${action.actions[i]?.details || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2">${moment(action.actions[i]?.startDate).format("DD/MM/YYYY") || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2">${moment(action.actions[i]?.endDate).format("DD/MM/YYYY") || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2 text-[#3b3b3b]">
                                ${action.actions[i]?.progress === "Problem"
                                ? "<i class='fas fa-frown'></i>"
                                : "<i class='fas fa-thumbs-up'></i>"
                            }
                            </td>
                            <td class="border border-gray-300 px-4 py-2">${action.actions[i]?.progress === "Problem" ? action.actions[i]?.problem : action.actions[i]?.progress || "N/A"}</td>
                        </tr>`;
                        if (action.actions[i]?.details) {
                            table3data1 += additionalRow;
                        }
                        // table3data1 += additionalRow;
                    }
                }
                else {
                    const firstRow = `
                    <tr class="bg-white text-gray-800">
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.riskId}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.title}</td>
                        <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">${action.owner.firstName} ${action.owner.lastName}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${action.actions[0]?.details || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${moment(action.actions[0]?.startDate).format("DD/MM/YYYY") || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${moment(action.actions[0]?.endDate).format("DD/MM/YYYY") || "N/A"}</td>
                        <td class="border border-gray-300 px-4 py-2 bg-white text-[#3b3b3b]">
                            ${action.actions[0]?.progress === "Problem"
                            ? "<i class='fas fa-frown'></i>"
                            : "<i class='fas fa-thumbs-up'></i>"
                        }
                        </td>
                        <td class="border border-gray-300 px-4 py-2 bg-white">${action.actions[0]?.progress === "Problem" ? action.actions[0]?.problem : action.actions[0]?.progress || "N/A"}</td>
                    </tr>`;
                    if (action.actions[0]?.details) {
                        table3data2 += firstRow;
                    }
                    // table3data2 += firstRow;

                    // Remaining rows for actions
                    for (let i = 1; i < action.actions?.length; i++) {
                        const additionalRow = `
                        <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                            <td class="border border-gray-300 px-4 py-2">${action.actions[i]?.details || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2">${moment(action.actions[i]?.startDate).format("DD/MM/YYYY") || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2">${moment(action.actions[i]?.endDate).format("DD/MM/YYYY") || "N/A"}</td>
                            <td class="border border-gray-300 px-4 py-2 text-[#3b3b3b]">
                                ${action.actions[i]?.progress === "Problem"
                                ? "<i class='fas fa-frown'></i>"
                                : "<i class='fas fa-thumbs-up'></i>"
                            }
                            </td>
                            <td class="border border-gray-300 px-4 py-2">${action.actions[i]?.progress === "Problem" ? action.actions[i]?.problem : action.actions[i]?.progress || "N/A"}</td>
                        </tr>`;
                        if (action.actions[i]?.details) {
                            table3data2 += additionalRow;
                        }
                        // table3data2 += additionalRow;
                    }

                }
            });

            table3data1 += `</tbody>
        </table>`;

            table3data2 += `</tbody>
        </table>`;

            setTable3data(table3data1);
            setTable3data2(table3data2);
        }
    }, [risk_actions, language]);



    React.useEffect(() => {
        if (risk_incidents) {
            ////console.log(risk_incidents);

            let datafortableincidents = "";
            let i = 0;
            risk_incidents.forEach(incident => {
                datafortableincidents += ` <table class="w-full border-collapse border border-gray-300 ${i !== risk_incidents?.length - 1 ? "mb-4" : ""}">

      <tbody>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Date" : "Olay Tarihi"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${moment(incident.reportDate).format("DD/MM/YYYY")}</td>
        </tr>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Related Risk" : "İlgili Risk"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${incident.risk_id + " - " + incident.title}</td>
        </tr>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Location" : "Olay Konumu"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${incident.location}</td>
        </tr>
        <!-- Describe Incident -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Describe Incident" : "Olayı Tanımla"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
            ${incident.description}
          </td>
        </tr>
        <!-- Incident Root Cause -->
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Root Cause" : "Olayın Temel Nedeni"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
${incident.root_cause}
           
          </td>
        </tr>
        <!-- Impact -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Impact" : "Etkiler"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
           ${incident.impact}
          </td>
        </tr>
        <!-- Corrective Action -->
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Corrective Action" : "Düzeltici Eylem"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
            ${incident.corrective_action}
          </td>
        </tr>
        <!-- Preventive Measures -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Preventive Measures" : "Önleyici Önlemler"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
           ${incident.preventive_measures}
          </td>
        </tr>
      </tbody>
    </table>`

                i++;
            });

            setTable4data(datafortableincidents);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risk_incidents, language]);



    // const currentQuarter = moment().quarter();
    // const quarterString = currentQuarter === 1 ? "Q1" : currentQuarter === 2 ? "Q2" : currentQuarter === 3 ? "Q3" : "Q4";
    // const quarterStarted = moment().startOf('quarter').format("DD/MM/YYYY");
    const currentQuarter = moment().quarter();

    const quarterString = `Q${currentQuarter}`;

    const reportingStartDates = {
        1: "01/04/YYYY",
        2: "01/07/YYYY",
        3: "01/10/YYYY",
        4: "01/01/YYYY"  // of next year
    };

    const currentYear = moment().year();
    const reportYear = currentQuarter === 4 ? currentYear + 1 : currentYear;

    const quarterStarted = reportingStartDates[currentQuarter].replace("YYYY", reportYear);

    const [exporting, setExporting] = React.useState(false);

    const handleExportP = async () => {
        setExporting(true);
        await GeneratePDF(componentRef);
        setExporting(false);
    }

    const handleExportV = async () => {
        setExporting(true);
        await generatePDF(componentRef);
        setExporting(false);
    }

    const formatTopRisksParagraph = (risks, language) => {
        const top5 = risks.slice(0, 5);
        if (language === 'en') {
            const riskList = top5.map(r => r.title).join(", ").replace(/, ([^,]*)$/, ", and $1");
            return `The following represent the top 5 most critical risks currently facing our department: ${riskList}. These risks pose significant threats to our strategic objectives. It is essential that we prioritize mitigation efforts around them to protect our operations, secure key assets, and ensure long-term resilience and growth.`;
        } else {
            const riskList = top5.map(r => r.title).join(", ").replace(/, ([^,]*)$/, " ve $1");
            return `Aşağıdakiler, şu anda departmanımızın karşı karşıya olduğu en kritik 5 riski temsil etmektedir: ${riskList}. Bu riskler, stratejik hedeflerimiz için ciddi tehditler oluşturmaktadır. Operasyonlarımızı korumak, kritik varlıkları güvence altına almak ve uzun vadeli dayanıklılık ile büyümeyi sağlamak için bu risklerin azaltılmasına öncelik verilmesi büyük önem taşımaktadır.`;
        }
    };

    const generateReportJSON = () => {
        console.log("Generating Json", editableName);
        return {
            editableName: {
                title: editableName.current.title,
                subtitle: editableName.current.subtitle,

                page1title: editableName.current.page1title,
                page1subtitle1: editableName.current.page1subtitle1,
                page1subtitle2: editableName.current.page1subtitle2,
                page1subtitle3: editableName.current.page1subtitle3,
                page1subtitle4: editableName.current.page1subtitle4,
                page1subtitle5: editableName.current.page1subtitle5,

                page2title: editableName.current.page2title,
                page2subtitle1: editableName.current.page2subtitle1,
                page2subtitle2: editableName.current.page2subtitle2,
                page2subtitle3: editableName.current.page2subtitle3,
                page2subtitle4: editableName.current.page2subtitle4,
                page2subtitle5: editableName.current.page2subtitle5,
                page2subtitle6: editableName.current.page2subtitle6,
                page2subtitle7: editableName.current.page2subtitle7,
                page2subtitle8: editableName.current.page2subtitle8,

                page3title: editableName.current.page3title,
                page3subtitle1: editableName.current.page3subtitle1,
                page3subtitle2: editableName.current.page3subtitle2,
                page3subtitle3: editableName.current.page3subtitle3,
                page3subtitle4: editableName.current.page3subtitle4,
                page3subtitle5: editableName.current.page3subtitle5,
                page3subtitle6: editableName.current.page3subtitle6,

                page4title: editableName.current.page4title,
                page4subtitle1: editableName.current.page4subtitle1,
                page4subtitle2: editableName.current.page4subtitle2,
                page4subtitle3: editableName.current.page4subtitle3,

                page5title: editableName.current.page5title,
                page5subtitle1: editableName.current.page5subtitle1,
                page5subtitle2: editableName.current.page5subtitle2,
                page5subtitle4: editableName.current.page5subtitle4,
                page5subtitle5: editableName.current.page5subtitle5,

                page6title: editableName.current.page6title,
                page6subtitle1: editableName.current.page6subtitle1,
                page6subtitle2: editableName.current.page6subtitle2,
                page6subtitle3: editableName.current.page6subtitle3,
                page6subtitle4: editableName.current.page6subtitle4,
                page6subtitle5: editableName.current.page6subtitle5,


                page7title: editableName.current.page7title,
                page7subtitle1: editableName.current.page7subtitle1,
                page7subtitle2: editableName.current.page7subtitle2,
                page7subtitle3: editableName.current.page7subtitle3,

                page8title: editableName.current.page8title,
                page8subtitle1: editableName.current.page8subtitle1,
                page8subtitle2: editableName.current.page8subtitle2,
                page8subtitle3: editableName.current.page8subtitle3,
                page8subtitle4: editableName.current.page8subtitle4,
                page8subtitle5: editableName.current.page8subtitle5,
                page8subtitle6: editableName.current.page8subtitle6,
                page8subtitle7: editableName.current.page8subtitle7,


                page9title: editableName.current.page9title,
                page9subtitle1: editableName.current.page9subtitle1,
                page9subtitle2: editableName.current.page9subtitle2,
                page9subtitle3: editableName.current.page9subtitle3,
                page9subtitle4: editableName.current.page9subtitle4,
                page9subtitle5: editableName.current.page9subtitle5,
                page9subtitle6: editableName.current.page9subtitle6,
                page9subtitle7: editableName.current.page9subtitle7,
                page9subtitle8: editableName.current.page9subtitle8,

                page10title: editableName.current.page10title,
                page10subtitle1: editableName.current.page10subtitle1,

                page11title: editableName.current.page11title,
                page11subtitle1: editableName.current.page11subtitle1,
            },

            other: {
                page4subtitle4: page4subtitle4,
                page5subtitle3: page5subtitle3,
                table3data2: table3data2,
                table4data: table4data,
            },

            charts: {
                // If you want to store base64 chart images or data-driven chart inputs
                // Add them here, like:
                // page2Chart: chartData2,
                // riskByDepartment: general_dashboard_data.risks_by_department,
            },

            metadata: {
                createdAt: new Date().toISOString(),
                language: language, // if using internationalization
            }
        };
    }

    const loadReportJSON = (reportData) => {
        console.log("Attempting to load Saved Report", reportData)

        if (!reportData || typeof reportData !== "object") return;

        const editable = reportData.json.editableName || {};
        const other = reportData.json.other || {};

        if (editableName?.current) {
            editableName.current.title = editable.title || "";
            editableName.current.subtitle = editable.subtitle || "";

            editableName.current.page1title = editable.page1title || "";
            editableName.current.page1subtitle1 = editable.page1subtitle1 || "";
            editableName.current.page1subtitle2 = editable.page1subtitle2 || "";
            editableName.current.page1subtitle3 = editable.page1subtitle3 || "";
            editableName.current.page1subtitle4 = editable.page1subtitle4 || "";
            editableName.current.page1subtitle5 = editable.page1subtitle5 || "";


            editableName.current.page2title = editable.page2title || "";
            editableName.current.page2subtitle1 = editable.page2subtitle1 || "";
            editableName.current.page2subtitle2 = editable.page2subtitle2 || "";
            editableName.current.page2subtitle3 = editable.page2subtitle3 || "";
            editableName.current.page2subtitle4 = editable.page2subtitle4 || "";
            editableName.current.page2subtitle5 = editable.page2subtitle5 || "";
            editableName.current.page2subtitle6 = editable.page2subtitle6 || "";
            editableName.current.page2subtitle7 = editable.page2subtitle7 || "";
            editableName.current.page2subtitle8 = editable.page2subtitle8 || "";

            editableName.current.page3title = editable.page3title || "";
            editableName.current.page3subtitle1 = editable.page3subtitle1 || "";
            editableName.current.page3subtitle2 = editable.page3subtitle2 || "";
            editableName.current.page3subtitle3 = editable.page3subtitle3 || "";
            editableName.current.page3subtitle4 = editable.page3subtitle4 || "";
            editableName.current.page3subtitle5 = editable.page3subtitle5 || "";
            editableName.current.page3subtitle6 = editable.page3subtitle6 || "";

            editableName.current.page4title = editable.page4title || "";
            editableName.current.page4subtitle1 = editable.page4subtitle1 || "";
            editableName.current.page4subtitle2 = editable.page4subtitle2 || "";
            editableName.current.page4subtitle3 = editable.page4subtitle3 || "";

            editableName.current.page5title = editable.page5title || "";
            editableName.current.page5subtitle1 = editable.page5subtitle1 || "";
            editableName.current.page5subtitle2 = editable.page5subtitle2 || "";
            editableName.current.page5subtitle4 = editable.page5subtitle4 || "";
            editableName.current.page5subtitle5 = editable.page5subtitle5 || "";

            editableName.current.page6title = editable.page6title || "";
            editableName.current.page6subtitle1 = editable.page6subtitle1 || "";
            editableName.current.page6subtitle2 = editable.page6subtitle2 || "";
            editableName.current.page6subtitle3 = editable.page6subtitle3 || "";
            editableName.current.page6subtitle4 = editable.page6subtitle4 || "";
            editableName.current.page6subtitle5 = editable.page6subtitle5 || "";

            editableName.current.page7title = editable.page7title || "";
            editableName.current.page7subtitle1 = editable.page7subtitle1 || "";
            editableName.current.page7subtitle2 = editable.page7subtitle2 || "";
            editableName.current.page7subtitle3 = editable.page7subtitle3 || "";

            editableName.current.page8title = editable.page8title || "";
            editableName.current.page8subtitle1 = editable.page8subtitle1 || "";
            editableName.current.page8subtitle2 = editable.page8subtitle2 || "";
            editableName.current.page8subtitle3 = editable.page8subtitle3 || "";
            editableName.current.page8subtitle4 = editable.page8subtitle4 || "";
            editableName.current.page8subtitle5 = editable.page8subtitle5 || "";
            editableName.current.page8subtitle6 = editable.page8subtitle6 || "";
            editableName.current.page8subtitle7 = editable.page8subtitle7 || "";

            editableName.current.page9title = editable.page9title || "";
            editableName.current.page9subtitle1 = editable.page9subtitle1 || "";
            editableName.current.page9subtitle2 = editable.page9subtitle2 || "";
            editableName.current.page9subtitle3 = editable.page9subtitle3 || "";
            editableName.current.page9subtitle4 = editable.page9subtitle4 || "";
            editableName.current.page9subtitle5 = editable.page9subtitle5 || "";
            editableName.current.page9subtitle6 = editable.page9subtitle6 || "";
            editableName.current.page9subtitle7 = editable.page9subtitle7 || "";
            editableName.current.page9subtitle8 = editable.page9subtitle8 || "";

            editableName.current.page10title = editable.page10title || "";
            editableName.current.page10subtitle1 = editable.page10subtitle1 || "";

            editableName.current.page11title = editable.page11title || "";
            editableName.current.page11subtitle1 = editable.page11subtitle1 || "";
        }

        // Restore external variables
        if (typeof page4subtitle4 !== "undefined") setPage4subtitle4(other.page4subtitle4) || setPage4subtitle4("");
        if (typeof page5subtitle3 !== "undefined") setPage5subtitle3(other.page5subtitle3) || setPage5subtitle3("");
        if (typeof table3data2 !== "undefined") setTable3data2(other.table3data2) || setTable3data2("");
        if (typeof table4data !== "undefined") setTable4data(other.table4data) || setTable4data("");


    };


    return (


        <div className="p-6 bg-white rounded-lg">
            {loading && <div className="flex justify-center items-center h-[50vh]">
                <img src={spinner} alt="Loading..." className="w-8 h-8" />
                <p className="ml-4 text-sm text-[#3b3b3b]">Generating Report...</p>
            </div>}
            {(!loading && parsing) && <div id="report-container" >
                {/* Title and Definition */}
                <div className="flex justify-between mb-4">
                    <div className="flex items-center gap-4">
                        <div className="relative inline-block text-left">
                            <button
                                type="button"
                                className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                disabled={exporting} // disable while exporting to prevent double click
                            >
                                {exporting ? "Generating PDF..." : "Export PDF ▾"}
                            </button>

                            {dropdownOpen && !exporting && (
                                <div className="absolute left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                                    <button
                                        className="w-full text-left px-4 py-3 text-sm text-[#3b3b3b] font-medium hover:bg-blue-50 transition rounded-md"
                                        onClick={handleExportV}
                                    >
                                        Export Visual PDF
                                    </button>

                                    <button
                                        className="w-full text-left px-4 py-3 text-sm text-[#3b3b3b] font-medium hover:bg-blue-50 transition rounded-md"
                                        onClick={handleExportP}
                                    >
                                        Export Print PDF
                                    </button>
                                </div>
                            )}
                        </div>


                        <select
                            value={language}
                            onChange={handleLanguageChange}
                            className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#3b3b3b]"
                        >
                            <option value="en">English</option>
                            <option value="tr">Türkçe</option>
                        </select>
                    </div>

                    <button onClick={() => closeReport(generateReportJSON())} className="">
                        <img src={CloseIcon} alt="Close" className="w-8 h-8" />
                    </button>
                </div>



                <div className="w-full" ref={componentRef} id="report-container">

                    <div id="page1" className="relative h-[500px]"> {/* Ensure the parent has height */}
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url("${bluemountain}")` }}
                        ></div>
                        {/*<div className="absolute inset-0 bg-[#bb133e] opacity-75"></div>*/}
                        <div className="relative z-10 flex items-center justify-center h-full"> {/* Full height for content alignment */}
                            <div className="border-2 border-white rounded-lg p-2">
                                <ContentEditable
                                    html={editableName.current.title}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    onChange={(e) => {
                                        ////console.log(e.target.value);
                                        editableName.current.title = e.target.value;
                                    }}
                                    tagName="h1"
                                    style={{
                                        color: "white",
                                        fontSize: "2rem",
                                        fontWeight: "bold",
                                    }}
                                />


                                <div className="flex items-center">
                                    <ContentEditable
                                        html={
                                            editableName.current.subtitle
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.subtitle = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "white",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr className="my-4"></hr>
                    <div id="page2" className="h-auto">
                        <div className="border-2 border-white rounded-lg ">
                            {/* <ReactQuill
                            ref={editorRef}
                            //value={editableName.current.page1title}
                            onChange={(value) => {
                            editableName.current.page1title = value;
                            }}
                            defaultValue={{
                                ops: [
                                { insert: editableName.current.page1title, attributes: { size: "large", bold: true } }, 
                                { insert: "\n" } // Ensures correct rendering
                                ]
                            }}
                            modules={{
                            toolbar: {
                                container: [
                                ["bold", "italic", "underline"],
                                [{ size: ["small", false, "large"] }],
                                [{ align: [] }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ],
                            },
                            }}
                            contentStyle={{ size: "large" }} 
                            theme="snow"
                            className={activeBox === "page1title" ? "show-toolbar" : "hide-toolbar"}
                            onFocus={() => setActiveBox("page1title")}
                            onBlur={(e) => {
                                setTimeout(() => {
                                  const activeElement = document.activeElement;
                                  if (!activeElement || !activeElement.closest('.ql-toolbar')) {
                                    setActiveBox(null);
                                  }
                                }, 0); }}
                            style={{
                                color: "#bb133e",
                                maxWidth: "600px", // Use maxWidth for better responsiveness
                            }}
                        /> */}
                            <ContentEditable
                                html={editableName.current.page1title}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        e.target.blur(); // Optional: blur on Enter
                                    }
                                }}
                                onChange={(e) => {
                                    editableName.current.page1title = e.target.value;
                                }}
                                tagName="h1" // Use h1 or p depending on your semantic needs
                                onFocus={() => setActiveBox("page1title")}
                                onBlur={(e) => {
                                    setTimeout(() => {
                                        const activeElement = document.activeElement;
                                        if (!activeElement || !activeElement.closest('.ql-toolbar')) {
                                            setActiveBox(null);
                                        }
                                    }, 0);
                                }}
                                style={{
                                    color: "#0081A7",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "600px",
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page1subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////console.log(e.target.value);
                                    editableName.current.page1subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#0081A7",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}

                            />





                            <ContentEditable
                                html={
                                    editableName.current.page1subtitle3
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////console.log(e.target.value);
                                    editableName.current.page1subtitle3 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                            <div className="grid grid-cols-2 gap-4">
                                <div className="col-span-1">
                                    <ContentEditable
                                        html={
                                            editableName.current.page1subtitle4
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page1subtitle4 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                    <ContentEditable
                                        html={
                                            editableName.current.page1subtitle5
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page1subtitle5 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                </div>
                                <div className="col-span-1 flex items-center justify-center h-full">
                                    <img src={page1chart} alt="Page 1 Chart" className="w-full h-auto max-w-full" />
                                </div>
                            </div>

                        </div>

                        <div className="border-2 border-white rounded-lg">



                            <ContentEditable
                                html={editableName.current.page2subtitle2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////console.log(e.target.value);
                                    editableName.current.page2subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />

                            <hr className="my-4"></hr>

                        </div>
                        <div id="page3" className="h-auto">
                            <div className="border-2 border-white rounded-lg ">
                                <div className="grid grid-cols-3 gap-x-4 gap-y-0">
                                    <div className="col-span-3 text-left mb-4">
                                    <ContentEditable
                                        html={editableName.current.page2title}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page2title = e.target.value;
                                        }}
                                        tagName="h1"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "600px",
                                        }}
                                    />
                                    <ContentEditable
                                        html={
                                            editableName.current.page2subtitle1
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page2subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}

                                    />

                                    <ContentEditable
                                        html={editableName.current.page2subtitle4}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page2subtitle4 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            
                                        }}
                                    />
                                    </div>
                                 

                                       
                               <div className="col-span-1">

                                    <ContentEditable
                                        html={table1data}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}

                                        tagName="div"
                                    />

                                </div>

                                <div className="col-span-1 text-left">
                                        <ContentEditable
                                        html={editableName.current.page4subtitle1}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page4subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginLeft: "30px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={
                                            editableName.current.page2subtitle8
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                                }
                                            }}
                                            onChange={(e) => {
                                                ////console.log(e.target.value);
                                                editableName.current.page2subtitle8 = e.target.value;
                                            }}
                                            tagName="p"
                                            style={{
                                                color: "#000",
                                                fontSize: "1rem",
                                                fontWeight: "normal",
                                                maxWidth: "88%", // Use maxWidth for better responsiveness
                                                marginLeft: "30px",
                                            }}
                                        />
                                    </div>

                                    <div className="col-span-1">
                                        {<RiskByDepartment height={(window.innerHeight - 330) / 3} risks_by_department={controls_by_department} />}
                                    </div>

                                    <div className="col-span-full text-left">
                                        <ContentEditable
                                        html={editableName.current.page3subtitle2}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page3subtitle2 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            
                                        }}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-4 gap-4 mt-4">
                                    <div className="col-span-1">
                                        {<SimplePercentagePieChart data={piecontrols_by_department} />}
                                    </div>

                                    <div className="col-span-1">
                                        <ContentEditable
                                        html={editableName.current.page5subtitle1}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page5subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            //marginLeft: "10px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={
                                            editableName.current.page5subtitle2
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                                }
                                            }}
                                            onChange={(e) => {
                                                ////console.log(e.target.value);
                                                editableName.current.page5subtitle2 = e.target.value;
                                            }}
                                            tagName="p"
                                            style={{
                                                color: "#000",
                                                fontSize: "1rem",
                                                fontWeight: "normal",
                                                maxWidth: "88%", // Use maxWidth for better responsiveness
                                                //marginLeft: "10px",
                                            }}
                                        />
                                    
                                    </div>
                                {/*<img src={page2chart} alt="Page 2 Chart" className="w-full h-auto max-w-full" />*/}
                                {/*<RiskByDepartment height={(window.innerHeight - 400) / 2} risks_by_department={general_dashboard_data.risks_by_department} />*/}
                                <div className="col-span-1 w-full flex flex-col items-center">
                                    

                                    

                                    <div className="w-full max-w-md flex justify-center">
                                        <SimplePercentageChart data={typecontrols_by_department} />
                                    </div>

                                </div>

                               
                                <div className="col-span-1">

                                   {/*<RiskLevelByDepartment height={(window.innerHeight - 375) / 2} data={general_dashboard_data.risk_level_by_department} />*/}
                                   {/*<SimplePercentageChart data = {typecontrols_by_department}/>*/}

                                    

                                   {/*<SimplePercentagePieChart data= {piecontrols_by_department}  />*/}

                                    <ContentEditable
                                        html={editableName.current.page2subtitle5}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page2subtitle5 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#0081A7",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={editableName.current.page2subtitle6}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////console.log(e.target.value);
                                            editableName.current.page2subtitle6 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                        </div>
                                

                                </div>

                            </div>
                        </div>

                    </div> 

                    <hr className="my-4"></hr>
                    <div id="page4" className="h-auto">
                        <ContentEditable
                            html={editableName.current.page3title}
                            disabled={false}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    ////console.log('Enter key pressed');
                                    e.target.blur();
                                }
                            }}
                            onChange={(e) => {
                                ////console.log(e.target.value);
                                editableName.current.page3title = e.target.value;
                            }}
                            tagName="h1"
                            style={{
                                color: "#0081A7",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                maxWidth: "600px",
                            }}
                        />

                        <ContentEditable
                            html={editableName.current.page3subtitle1}
                            disabled={false}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    ////console.log('Enter key pressed');
                                    e.target.blur();
                                }
                            }}
                            onChange={(e) => {
                                ////console.log(e.target.value);
                                editableName.current.page3subtitle1 = e.target.value;
                            }}
                            tagName="p"
                            style={{
                                color: "#000",
                                fontSize: "1rem",
                                fontWeight: "normal",
                                maxWidth: "100%", // Use maxWidth for better responsiveness
                            }}
                        />


                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={table2data1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />



                        </div>
                    </div>


                    <hr className="my-4"></hr>

                    <div id="page5" className="relative h-[500px]"> {/* Ensure the parent has height */}
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url("${bluemountain}")` }}
                        ></div>
                        {/*<div className="absolute inset-0 bg-[#bb133e] opacity-75"></div>*/}
                        <div className="relative z-10 flex flex-col items-center justify-center h-full"> {/* Full height for content alignment */}
                            <div className="border-2 border-white rounded-lg p-2">
                                <ContentEditable
                                    html={"FIN AND FIND RISK TEAM"}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    onChange={(e) => {
                                        ////console.log(e.target.value);
                                        editableName.current.title = e.target.value;
                                    }}
                                    tagName="h1"
                                    style={{
                                        color: "white",
                                        fontSize: "2rem",
                                        fontWeight: "bold",
                                    }}
                                />

                            </div>


                            <div className="relative z-10 flex items-center justify-center mt-6"> {/* Full height for content alignment */}
                                <ContentEditable
                                    html={language === "en" ? `Empowering Decisions Through Insightful Risk Management – Together Towards a Secure Future` : `Karar Vermeye İzin Verici Risk Yönetimi – Birlikte Geleceğe Güven`}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    tagName="p"
                                    style={{
                                        color: "#ffffff",
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        maxWidth: "100%", // Use maxWidth for better responsiveness
                                    }}
                                />



                            </div>

                        </div>


                    </div>




                </div >

            </div >}

        </div >
    );
};

const mapStateToProps = (state) => {
    //console.log("Report Data", state)
    
    return {

        general_dashboard_data: state.dashboard.general_dashboard_data,
        department_dashboard_data: state.dashboard.department_dashboard_data,
        risks_report: state.risk.risks_report,
        all_risks_report: state.risk.all_risks_report,
        risk_controls: state.risk.risk_controls,
        risk_actions: state.risk.risk_actions,
        risk_incidents: state.risk.risk_incidents,
        levels: state.risk.levels,
        all_departments: state.department.departments,
        all_risk_controls: state.risk.all_risk_controls,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getGeneralDashboardDataFN: () => dispatch(getGeneralDashboardData()),
        getDepartmentDashboardDataFN: (activeDepartmentId) => dispatch(getDepartmentDashboardData(activeDepartmentId)),
        getAllDepartmentsFN: () => dispatch(getAllDepartments()),
        getRisks_ReportFN: (department_id) => dispatch(getRisks_Report(department_id)),
        getAllRisks_ReportFN: () => dispatch(getAllRisks_Report()),
        getControls_ReportFN: (department_id) => dispatch(getControls_Report(department_id)),
        getActions_ReportFN: (department_id) => dispatch(getActions_Report(department_id)),
        getIncidents_ReportFN: (department_id) => dispatch(getIncidents_Report(department_id)),
        getControlsSearchFN: (departmentId) => dispatch(getControls_Search(departmentId)),
        getLevelsFN: () => dispatch(getLevels()),
        getReportsFN: () => dispatch(getReports()),
        getReportFN: (id) => dispatch(getReport(id)),
        createReportFN: (title, json, type) => dispatch(createReport(title, json, type)),
        deleteReportFN: () => dispatch(deleteReport()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ControlReport);